export default __webpack_public_path__ + "static/media/carta-mobile.ffdcad6b.png";